import { useEffect, useState } from 'preact/hooks';

/** After this long, say why it is taking a while (the detection model is waking up). */
const SLOW_MS = 8_000;

/** Shown over the customer's photo while the floor is being detected. */
export function ScanningOverlay() {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    const id = setTimeout(() => setSlow(true), SLOW_MS);
    return () => clearTimeout(id);
  }, []);

  return (
    <div class="pointer-events-none absolute inset-0 overflow-hidden" role="status" aria-live="polite">
      <div class="fv-scan absolute inset-x-0 h-1/3" />
      <div class="absolute inset-x-0 bottom-4 flex justify-center px-4">
        <span class="flex items-center gap-2 rounded-full bg-black/65 px-4 py-2 text-center text-sm font-semibold text-white backdrop-blur">
          <span class="h-2 w-2 shrink-0 animate-pulse rounded-full bg-accent" />
          {slow ? 'Still working: the first photo can take up to a minute...' : 'Finding your floor...'}
        </span>
      </div>
    </div>
  );
}
